/**
* @file Column component for displaying a open slot value
* @author Heino Lenting
*/
import * as tslib_1 from "tslib";
import { ChangeDetectorRef } from '@angular/core';
import { ColumnBase } from '../column-base/column-base';
import { ColumnProvider } from '../../column-provider';
import { ComponentRegistry } from '../../../core/component-registry';
/**
 * Column component for displaying a open slot value
 */
var ColumnOpenSlotComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ColumnOpenSlotComponent, _super);
    /**
     * Constructs a ColumnOpenSlotComponent
     */
    function ColumnOpenSlotComponent(provider, changeDetector) {
        return _super.call(this, provider, changeDetector) || this;
    }
    /**
     * Register this column class for the column provider
     */
    ColumnOpenSlotComponent.register = function () {
        ComponentRegistry.register('column', 'open-slot', ColumnOpenSlotComponent);
    };
    /**
     * Returns a string representation of the resource
     * @returns {string} A string representation of the resource
     */
    ColumnOpenSlotComponent.prototype.getDisplayValue = function () {
        return (this.provider.value['FirstName'] + ' ' + this.provider.value['Prefix'] + ' ' + this.provider.value['Name']).trim();
    };
    return ColumnOpenSlotComponent;
}(ColumnBase));
export { ColumnOpenSlotComponent };
